<main class="login antialiased">
  <!-- <section class="login-art">
    <div class="logo">AT</div>
    <div>
      <p class="eyebrow">ALL TO TRIPS</p>
      <h1>จัดการทุกการเดินทาง<br /><em>ให้เป็นเรื่องง่าย</em></h1>
      <p>ระบบบริหารงานหลังบ้านสำหรับทีมทัวร์ ตั้งแต่รับลูกค้า จนถึงปิดยอดและชำระค่าใช้จ่าย</p>
    </div>
    <small>© 2026 All To Trips</small>
  </section>  -->
  <section class="login-panel">
    <form [formGroup]="form" (ngSubmit)="submit()">
      <div class="mobile-logo">AT</div>
      <p class="eyebrow">ยินดีต้อนรับ</p>
      <h2>เข้าสู่ระบบ</h2>
      @if (errorMessage()) {
        <p class="form-error" role="alert">{{ errorMessage() }}</p>
      }
      <label>ชื่อผู้ใช้<input formControlName="username" placeholder="กรอกชื่อผู้ใช้" /></label>
      <label>
        รหัสผ่าน
        <input type="password" formControlName="password" placeholder="กรอกรหัสผ่าน" />
      </label>
      
      <button
        type="submit"
        class="mt-2 flex w-full items-center justify-center rounded-lg bg-[var(--theme-color)] px-4 py-3 text-sm font-semibold text-white shadow-sm transition hover:bg-[var(--theme-hover)] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--theme-color)] active:scale-[0.99] disabled:cursor-not-allowed disabled:opacity-50"
        [disabled]="form.invalid || submitting()"
      >
        {{ submitting() ? 'กำลังเข้าสู่ระบบ...' : 'เข้าสู่ระบบ →' }}
      </button>
      <small class="muted mt-7 text-center">
        © 2026 All To Trips
        <span class="mt-1 block">เวอร์ชัน {{ appVersion }}</span>
      </small>
    </form>
  </section>
</main>
